import angular from 'angular';
import uiRouter from 'angular-ui-router';
import regionComponent from './region.component';
import regionListComponent from './region-list.component';
import regionDetailComponent from './region-detail.component';
import regionService from './region.service';

let regionModule = angular.module('region', [
  uiRouter
])

.service('Region', regionService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/region');

  $stateProvider
    .state('region', {
      component: 'region'
    })
    .state('region.list', {
      url: '/region',
      component: 'regionList'
    })
    .state('region.create', {
      url: '/region/new',
      component: 'regionDetail',
      params: {
      	id: ""
      }
    })
    .state('region.edit', {
      url: '/region/:id/edit',
      component: 'regionDetail',
      params: {
        id: ""
      }
    });
})

.component('region', regionComponent)
.component('regionList', regionListComponent)
.component('regionDetail', regionDetailComponent)

.name;

export default regionModule;



// WEBPACK FOOTER //
// ./client/app/components/region/region.js